module.exports = __webpack_public_path__ + "images/emoji/globe_with_meridians.5d50dcc50cbdc687972e.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/globe_with_meridians.png
// module id = 8JqG
// module chunks = 13